import DashboardConstants from "@/store/constants/dashboardRecords";
import TrashIcon from "@/components/shared/TrashIcon"
import GlobalConstants from "@/store/constants/global"
export default {
  name: 'AttachedImageModal',
  components: {
    TrashIcon
  },
  props: ['url', 'isPdf'],
  data() {
    return {
      isNew: true,
    };
  },
  methods: {
    showConfirmModal() {
      this.$bvModal.show('confirm-modal');
      this.$store.commit(GlobalConstants.COMMIT.setConfirmAttr, { attr: "attachedImageUrl", orderId: -1 });
    }
  },
  computed: {
    // REFACTOR: add filter global
    statusEditable() {
      return this.$store.getters[DashboardConstants.GETTERS.getStatusEditable];
    },
  }
};
